import React from "react";
import { X, Mail, Clock } from "lucide-react";
import Avatar from "components/ui/Avatar";
import { getRelativeTime } from "services/date-converter";

const StepRecipients = ({ resolvedRecipients, removeRecipient, resolving }) => {
  if (resolving) {
    return <p className="text-sm text-text_secondary">Resolving audience…</p>;
  }

  if (resolvedRecipients.length === 0) {
    return <p className="text-sm text-text_secondary">No recipients matched your filters.</p>;
  }

  return (
    <div className="space-y-3">
      <p className="text-xs text-text_secondary">
        <span className="font-semibold text-text_primary">{resolvedRecipients.length}</span> recipient(s) will receive this campaign. Remove anyone who shouldn't be included.
      </p>

      <div className="max-h-[360px] overflow-y-auto rounded-lg border border-border divide-y divide-border">
        {resolvedRecipients.map((u) => (
          <div key={u.id} className="flex items-center gap-3 px-3 py-2.5">
            <div className="flex-shrink-0">
              <Avatar user={u} size={32} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-medium text-text_primary truncate">
                {`${u.first_name || ""} ${u.last_name || ""}`.trim() || "—"}
              </div>
              <div className="flex items-center gap-1 text-[11px] text-text_muted truncate">
                <Mail size={10} className="flex-shrink-0" />
                {u.email}
                {u.company_name && <span className="truncate"> · {u.company_name}</span>}
              </div>
              <div className="flex items-center gap-1 text-[10px] text-text_muted mt-0.5">
                <Clock size={9} className="flex-shrink-0" />
                {u.last_login_date ? `Last login ${getRelativeTime(u.last_login_date)}` : "Never logged in"}
              </div>
            </div>
            {u.role && (
              <span className="flex-shrink-0 text-[10px] font-medium text-text_secondary bg-surface_alt border border-border rounded-md px-1.5 py-0.5">
                {u.role}
              </span>
            )}
            <button
              type="button"
              onClick={() => removeRecipient(u.id)}
              className="flex-shrink-0 p-1.5 rounded-lg bg-danger_bg text-danger"
              title="Remove"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepRecipients;
